import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { ReceptionTableColumnHeader } from './ReceptionTableColumnHeader'
import { useMemo } from 'react'
import '../styles.scss'
import { useTranslation } from 'react-i18next'

export const ReceptionTable = ({ data, onQuantityChange }) => {
    const rows = useMemo(() => (Array.isArray(data) ? data : []), [data])
    const { t } = useTranslation()

    const columns = useMemo(
        () => ReceptionTableColumnHeader({ onQuantityChange, t }),
        [onQuantityChange, t]
    )

    const table = useReactTable({
        data: rows,
        columns,
        getCoreRowModel: getCoreRowModel(),
    })

    return (
        <table id='tableReception'>
            <thead>
                {table.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map(header => (
                            <th key={header.id}>
                                {header.isPlaceholder
                                    ? null
                                    : flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody>
                {table.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => (
                            <td key={cell.id}>
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    )
}